import { CLEAR_TEST_DRIVE } from '../actionTypes/testDriveActionTypes';

export const clearTestDrive = () => ({ type: CLEAR_TEST_DRIVE });
